const RYADOM_CLINIC_ID = 55
const SEMBINOVA_EMAIL = 'info@emd.kz'

export function canAccessUltrasound(profile) {
  if (!profile?.clinic) return false
  if (typeof profile.ultrasound_access === 'boolean') return profile.ultrasound_access
  const clinicId = typeof profile.clinic === 'object' ? profile.clinic.id : profile.clinic
  const email = String(profile.user?.email || '').trim().toLowerCase()
  return Number(clinicId) === RYADOM_CLINIC_ID || email === SEMBINOVA_EMAIL
}
